/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-unused-vars */
import { memo, useMemo, useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import { useStore, useStoreApi } from '@tmsw/powerups.store';
import { useVieConfig } from '@tmsw/powerups.vie.hooks.use-vie-config';
import { useTranslation } from '@tmsw/powerups.intl.hooks.use-translation';
// import { useSoundEffects } from '@tmsw/powerups.audio.hooks.use-sound-effects';
import { useSoundEffects } from '../../hooks/useSoundEffects';
import { usePrevious } from '@tmsw/powerups.hooks.use-previous';
// import { useGlobalListener } from '@tmsw/powerups.hooks.use-global-listener';
// import { useMusicPlayer } from '@tmsw/powerups.audio.hooks.use-music-player';
import { useMusicPlayer } from '../../hooks/useMusicPlayer';
import { getLevelConfig } from './HexGame/services/getLevelConfig';
import { getBySlug } from '../../services/getBySlug';
import { useAudioPlayerEffects } from '../../hooks/useAudioPlayerEffects';
import useScoreboard from './HexGame/hooks/useScoreboard';
import { Loader } from '@tmsw/powerups.ui.loaders.base';
import { propsAreEqual } from '@tmsw/powerups.utils.props-are-equal';
// import { useReactAudioContext } from '@tmsw/powerups.audio.provider';
import './GamePlay.css';

// local imports
import { HexGame } from './HexGame';
// import { useCallbackRef } from '@radix-ui/react-use-callback-ref';

function remapSfx(sfxConfigRaw: LocaleJson.SoundEffects) {
  return Object.fromEntries(
    sfxConfigRaw.map((obj) => {
      return [obj.slug, obj.url];
    })
  );
}

// @ts-ignore
const GamePlay = ({ goToPage, goToNextPage }) => {
  const { __t } = useTranslation('GAME_PLAY');
  // const pageRef = useRef(document.getElementById('Page-Wrapper'));
  // const [ready, setReady] = useState(false);
  const gameLevel = useStore((state) => state.gameCharacter) || 'pikachu';
  const showGameBoard = useStore((state) => state.showGameBoard);
  const setShowGameBoard = useStore((state) => state.setShowGameBoard);
  const currentCueMetadata = useStore((state) => state.currentCueMetadata);
  // const { players } = useReactAudioContext();
  // const setInitialState = useStore((state) => state.setInitialState);
  const state = useStoreApi().getState();
  const { streakCount, progressPercentage, hitsCount, movesCount } =
    useScoreboard();

  // console.log({ streakCount, progressPercentage, hitsCount, movesCount });

  const playSfx = useSoundEffects({
    urls: remapSfx(__t('soundEffects')),
  });

  const musicPlayerRef = useRef(
    useMusicPlayer(__t('audioConfig.music', 'GAME_PLAY'), {})
  );

  const getRandomTheme = () => {
    const themes = __t('themes');
    const urlParam = new URLSearchParams(window.location.search).get('theme');
    if (urlParam !== null) return themes.find((t: any) => t.slug === urlParam);
    return themes[Math.floor(Math.random() * themes.length)];
  };

  useEffect(() => {
    const { set, gamePlayCount, setGamePlayCount } = state;

    if (!gamePlayCount) {
      set((state: any) => {
        state.gamePlayCount = 0;
      });
    }

    if (!setGamePlayCount) {
      set((state: any) => {
        state.setGamePlayCount = (v: number) =>
          set((state: any) => {
            state.gamePlayCount = v;
          });
      });
    }
  }, []);

  const gamePlayCount = useStore((state) => state.gamePlayCount) || 0;
  const setGamePlayCount = useStore((state) => state.setGamePlayCount);

  const themeRef = useRef(getRandomTheme());

  // useGlobalListener(
  //   'VIE_READY',
  //   () => {
  //     setReady(true);
  //   },
  //   {}
  // );

  const config = useMemo(() => {
    const { gameConfig } = getBySlug(
      __t('levels'),
      gameLevel
    ) as LocaleJson.GameLevel;
    // const { gameConfig } = levelData;
    const levelConfig = getLevelConfig({
      inputBoard: { ...__t('gameConfig.board'), ...gameConfig.board },
      inputPieces: gameConfig.pieces,
      gameLevel,
    });

    return {
      ...levelConfig,
      progressLevel: __t('progressLevel'),
      playSfx: playSfx,
      theme: themeRef.current,
      videoContainer: document.querySelector('.video-container') as HTMLElement,
      vieConfig: __t('vieConfig'),
    };
  }, [gameLevel]);

  useAudioPlayerEffects();

  const { updateVieConfig } = useVieConfig({
    ...config.vieConfig,
    // overlays: <HexGame config={config} />,
    overlays: createPortal(
      <HexGame config={config} />,
      document.getElementById('Page-Wrapper') as HTMLElement
    ),
  });

  const prevValue = usePrevious({
    streakCount,
    hitsCount,
    showGameBoard,
    progressPercentage,
  });

  const setPageTitle = useStore((state) => state.setPageTitle);
  const showSettingsPanel = useStore((state) => state.showSettingsPanel);
  const isPauseEnabled = useStore((state) => state.isPauseEnabled);
  const inPortrait = useStore((state) => state.inPortrait);

  // useEffect(() => {
  //   if (musicPlayer?.buffer.loaded && musicPlayer.state === 'stopped') {
  //     console.log('Restarting music player');
  //     musicPlayer.restart(0);
  //   }
  //   // eslint-disable-next-line react-hooks/exhaustive-deps
  // }, []);

  useEffect(() => {
    setPageTitle(__t('pageTitle'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [showSettingsPanel, isPauseEnabled, inPortrait]);

  useEffect(() => {
    console.log('GamePlay useEffect', {
      hitsCount,
      movesCount,
      progressPercentage,
    });

    let vieConfig = { ...config.vieConfig };
    console.log('progressPercentage=', progressPercentage);
    if (
      // @ts-ignore
      progressPercentage !== prevValue?.progressPercentage &&
      progressPercentage >= 100
    ) {
      // musicPlayer?.stop(0);
      vieConfig.skipChapter = `CHAPTER_COMPLETION_IN`;
      // @ts-ignore
    } else if (prevValue?.progressPercentage < 75 && progressPercentage >= 75) {
      vieConfig.skipChapter = `CHAPTER_PROGRESS75_IN`;
      // @ts-ignore
    } else if (prevValue?.progressPercentage < 50 && progressPercentage >= 50) {
      vieConfig.skipChapter = `CHAPTER_PROGRESS50_IN`;
      // @ts-ignore
    } else if (prevValue?.progressPercentage < 25 && progressPercentage >= 25) {
      // @ts-ignore
      vieConfig.skipChapter = `CHAPTER_PROGRESS25_IN`;
    } else {
      vieConfig.skipChapter = null;
    }

    // console.log('progressText: ', progressText);

    // vieConfig.overlays = <HexGame config={config} />;

    updateVieConfig({
      skipChapter: vieConfig.skipChapter,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [streakCount, hitsCount, showGameBoard, progressPercentage]);

  //TODO: HACK - Looking for idle or FadeInBoard chapters to show the game board
  useEffect(() => {
    if (
      currentCueMetadata &&
      currentCueMetadata != null &&
      currentCueMetadata?.id?.length
    ) {
      if (currentCueMetadata?.id === 'CHAPTER_COMPLETION_IDLE_LOOP') {
        setGamePlayCount(gamePlayCount + 1);
        goToNextPage();
      }
      const newShowGameBoard =
        (currentCueMetadata?.id?.toLowerCase().includes('progress') === false &&
          currentCueMetadata?.id?.toLowerCase().includes('completion') ===
            false) ||
        currentCueMetadata?.id?.toLowerCase().includes('idle_loop') === true;
      console.log(
        'CURRENT CHAPTER: ',
        currentCueMetadata?.id,
        'showGameBoard=',
        newShowGameBoard
      );
      setShowGameBoard(newShowGameBoard);
    }
    /* eslint-disable-next-line react-hooks/exhaustive-deps */
  }, [currentCueMetadata]);

  // return ready ? null : <Loader />;
  // return <HexGame config={config} />;
  return null;
};

// GamePlay.whyDidYouRender = true;

export { GamePlay };
